import React from 'react';
import { Link } from 'react-router-dom';

const InternalServerErrorPage = () => {
  return (
    <div className="error-page">
      <h1>500 Internal Server Error</h1>
      <p>Oops! Something went wrong on our end. Please try again later.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default InternalServerErrorPage;
